import { render, staticRenderFns } from "./ui-portal.component.vue?vue&type=template&id=20746ef6&"
import script from "./ui-portal.component.vue?vue&type=script&lang=ts&"
export * from "./ui-portal.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports